´<template>
  <div class="instituicao-content">
    <div class="instituicao-bg" />
    <div>
      <div class="centered-div">
        <ul class="nav navbar-top-links navbar-right help-link">
          <li @click="help">
            <a>
              <i class="fa fa-question-circle fa-fw" />
              {{ $t('help') }}
            </a>
          </li>
        </ul>
        <!-- <div class="help-panel">
          <button class="btn btn-white btn-lg" @click="help" data-toggle="tooltip" data-placement="bottom" title="Ajuda"><i class="fa fa-question help-button"></i></button>
        </div>-->
        <img id="logo-sistema" :src="logoSource" class="logo-sistema" alt />
        <h1 class="header">{{ $t('instituicao.choose') }}</h1>
        <p class="lead">{{ $t('instituicao.help') }}</p>
        <p class="lead">{{ $t('instituicao.change_tip') }}</p>
        <ul id="instituicao" class="list-inline instituicao">
          <li class="instituicao-item">
            <div class="instituicao-logo" @click="selectInstituicao()">
              <i class="fa fa-user instituicao-default" />
            </div>
            <h4 class="instituicao-nome">{{ userName }}</h4>
          </li>
          <li
            v-for="instituicao in instituicoes"
            :key="instituicao.Id"
            class="instituicao-item"
          >
            <div
              class="instituicao-logo"
              @click="selectInstituicao(instituicao)"
            >
              <img :src="instituicao.Logo" class />
            </div>
            <h4 class="instituicao-nome">{{ instituicao.Nome }}</h4>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="loading">
      <div class="overlay" />
      <i class="fa fa-circle-o-notch fa-spin loader" />
    </div>
  </div>
</template>

<script>
import hopscotch from 'hopscotch'
import axios from 'axios'
import store from '../../store'
import { mapGetters } from 'vuex'
import { getUserData } from '../../lib/token'
import hideLoading from '../../lib/hideLoading'
import LogoProduction from '../../assets/images/imea-logo.svg'
import LogoHomolog from '../../assets/images/imea-logo-homolog.svg'
import LogoDevelopment from '../../assets/images/imea-logo-development.svg'

export default {
  name: 'Instituicao',
  beforeRouteEnter(to, from, next) {
    const userData = getUserData()
    if (userData) {
      const { access_token } = userData
      axios.defaults.headers.common['Authorization'] = `bearer ${access_token}`
    }
    Promise.all([
      store.dispatch('ping/requestData'),
      store.dispatch('menu/requestInstituicoes')
    ]).then(() => next())
  },
  beforeRouteLeave(to, from, next) {
    hopscotch.endTour(true)
    next()
  },
  mounted() {
    hideLoading()
  },
  created() {
    const userData = getUserData()
    const UserName = userData.Nome || ''

    this.$analytics.setUserProperties({
      UserName,
      InstituicaoName: ''
    })

    document.title = 'Minhas Instituições - IMEA'
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
  },
  computed: {
    ...mapGetters('menu', ['instituicoes']),
    userName() {
      return getUserData().Nome
    },
    logoSource() {
      switch (process.env.VUE_APP_MODE) {
        case 'production':
          return LogoProduction
        case 'homolog':
          return LogoHomolog
        default:
          return LogoDevelopment
      }
    }
  },
  methods: {
    help() {
      hopscotch.startTour(this.tour)
    },
    selectInstituicao(instituicao) {
      this.loading = true
      const data = instituicao ? JSON.stringify(instituicao) : ''
      window.localStorage.setItem('imea.portal.instituicao', data)
      if (instituicao) {
        this.$router.push({ name: 'dashboard' })
      } else {
        this.$router.push({ name: 'serie-index' })
      }
    }
  },
  data() {
    return {
      loading: false,
      tour: {
        id: 'instituicao-tour',
        i18n: {
          nextBtn: this.$t('tour_next'),
          prevBtn: this.$t('tour_prev'),
          doneBtn: this.$t('tour_done'),
          skipBtn: this.$t('tour_skip'),
          closeTooltip: this.$t('tour_close'),
          stepNums: ['1', '2', '3']
        },
        steps: [
          {
            title: this.$t('instituicao.tour[0].title'),
            content: this.$t('instituicao.tour[0].content'),
            target: 'instituicao',
            placement: 'left'
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.help-panel {
  position: absolute;
  right: 25px;
  top: 25px;
}

.help-link {
  position: absolute;
  right: 0;
  top: 0;
}

.nav.navbar-right > li > a {
  color: #f5f5f5;
}
</style>
